export default "__VITE_ASSET__CcCJfy1F__"